import styled from "styled-components";

// INFORMACP-4684: mesmo padrao de filtro da tela de Analytics de Seguros - espacamento fixo de
// 16px, margem nos dois lados e largura distribuida por flex. Sem as regras de flex nos filhos, o
// Select multiplo de eventos colapsava para largura quase zero e nao mostrava nem as tags nem o
// placeholder.
export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
  margin-left: 12px;
  margin-right: 12px;
  width: calc(100% - 24px);

  /* Ano da Edicao: campo curto, largura fixa */
  & > *:nth-child(1) {
    flex: 0 0 160px;
    min-width: 160px;
  }

  /* Eventos e Documentos dividem o espaco restante */
  & > *:nth-child(2),
  & > *:nth-child(3) {
    flex: 1 1 0;
    min-width: 0;
  }

  @media (max-width: 768px) {
    & > *:nth-child(1),
    & > *:nth-child(2),
    & > *:nth-child(3) {
      flex: 1 1 100%;
      min-width: 0;
    }
  }
`;

export const RequiredFieldHint = styled.p`
  margin: 0 12px 16px 12px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
`;

export const ContentBordered = styled.div`
  width: 100% !important;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding-top: 16px;
  border: 1px solid var(--light-2, rgba(235, 235, 240, 1));
  justify-content: center;
  height: auto;
  padding-bottom: 5px;
`;
